import apiClient from '../client';
import { APIResponse, ContentItem, ContentListResponse, ContentListParams } from '@memriti/shared';


export const contentService = {
  listContent: async (params: ContentListParams): Promise<APIResponse<ContentListResponse>> => {
    const queryParams: Record<string, any> = {};

    if (params.page) queryParams.page = params.page;
    if (params.per_page) queryParams.per_page = params.per_page;

    if (params.content_types?.length) {
      queryParams.content_types = params.content_types.join(',');
    }

    if (params.topic_ids?.length) {
      queryParams.topic_ids = params.topic_ids.join(',');
    }

    if (params.subtopic_ids?.length) {
      queryParams.subtopic_ids = params.subtopic_ids.join(',');
    }

    if (params.microtopic_ids?.length) {
      queryParams.microtopic_ids = params.microtopic_ids.join(',');
    }

    if (params.difficulties?.length) {
      queryParams.difficulties = params.difficulties.join(',');
    }

    if (params.company_tag_ids?.length) {
      queryParams.company_tag_ids = params.company_tag_ids.join(',');
    }

    const response = await apiClient.get('/api/v1/content', { params: queryParams });
    return response.data;
  },

  getContent: async (id: number): Promise<APIResponse<ContentItem>> => {
    const response = await apiClient.get(`/api/v1/content/${id}`);
    return response.data;
  },

  getMicrotopicContent: async (microtopicId: number, contentType?: string): Promise<APIResponse<ContentItem[]>> => {
    const params = contentType ? { content_type: contentType } : {};
    const response = await apiClient.get(`/api/v1/content/microtopic/${microtopicId}`, { params });
    return response.data;
  },

  getSubtopicContentCount: async (subtopicId: number): Promise<APIResponse<{
    subtopic_id: number;
    subtopic_name: string;
    content_count: number;
    microtopic_count: number;
    content_counts?: Record<string, number>;
  }>> => {
    const response = await apiClient.get(`/api/v1/content/count/subtopic/${subtopicId}`);
    return response.data;
  },

  getMicrotopicContentCount: async (microtopicId: number): Promise<APIResponse<{
    microtopic_id: number;
    microtopic_name: string;
    content_count: number;
    content_counts?: Record<string, number>;
  }>> => {
    const response = await apiClient.get(`/api/v1/content/count/microtopic/${microtopicId}`);
    return response.data;
  },
};